<div class="ptb-100">
    <div class="container-fluid bg-secondary p-3 d-flex align-items-center">
        <div class="container d-flex align-items-center ">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item text-white"><a class="text-white" href="#">Home</a></li>
                    <li class="breadcrumb-item active text-white" aria-current="page">Business Network</li>
                </ol>
            </nav>
        </div>
    </div><br />
    <div class="container">
        <img src="assets\img\images\Comingsoon.png" />
    </div>
</div>
